import { useState, useEffect } from "react";
import { Camera, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { API, formatApiError } from "@/lib/api";

export default function EmployeePhotos({ t }) {
  const [users, setUsers] = useState([]);
  const [bust, setBust] = useState(Date.now());
  const load = () => api.get("/users").then((r) => setUsers(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (u, file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(`/users/${u.id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Dodano zdjęcie"); setBust(Date.now()); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const del = async (u) => {
    try { await api.delete(`/users/${u.id}/photo`); toast.success("Usunięto zdjęcie"); setBust(Date.now()); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const withPhoto = users.filter((u) => u.photo_path);
  return (
    <div data-testid="employee-photos">
      <p className="text-[11px] text-slate-400 mb-3">{t("Podgląd i zarządzanie zdjęciami pracowników (używane na identyfikatorach). Zdjęcia dodasz też w panelu „Pracownicy”.")}</p>
      {withPhoto.length === 0 && <p className="text-xs text-slate-500 mb-3">{t("Brak wgranych zdjęć.")}</p>}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {withPhoto.map((u) => (
          <div key={u.id} className="bg-slate-900 border border-slate-700 rounded-lg p-2 text-center" data-testid={`emp-photo-${u.id}`}>
            <div className="w-full aspect-square rounded-md overflow-hidden bg-slate-800 mb-1.5">
              <img src={`${API}/users/${u.id}/photo?t=${bust}`} alt={u.name} className="w-full h-full object-cover" />
            </div>
            <div className="text-[11px] text-slate-300 truncate">{u.name}</div>
            <button onClick={() => del(u)} data-testid={`emp-photo-del-${u.id}`} className="mt-1 text-[11px] text-red-400 hover:text-red-300 inline-flex items-center gap-1"><Trash2 size={12} /> {t("Usuń")}</button>
          </div>
        ))}
      </div>
      <div className="mt-3 border-t border-slate-800 pt-3">
        <div className="text-xs font-semibold text-slate-300 mb-1.5">{t("Wgraj zdjęcie pracownikowi")}</div>
        <div className="flex flex-wrap gap-2">
          {users.map((u) => (
            <label key={u.id} className="text-[11px] bg-slate-700 hover:bg-slate-600 rounded px-2 py-1.5 cursor-pointer inline-flex items-center gap-1" data-testid={`emp-photo-upload-${u.id}`}>
              <Camera size={12} /> {u.name}
              <input type="file" accept="image/*" className="hidden" onChange={(e) => upload(u, e.target.files[0])} />
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
